import store from '@/store';
import router from '@/router';
import { removePrefix } from '../api/utils';

export async function validateLogin () {
  console.log('Looking for a previous session');
  let uri = window.location.search.substring(1); 
  let params = new URLSearchParams(uri);
  let sessionInUrl = params.get('session');
  if (sessionInUrl)
  {
    console.log('Session in URL');
    localStorage.setItem('jwt', sessionInUrl);
    let action = await ibb.getAccountInfo();
    if (!action.error.type) {
      let accountHandle = action.accountInfo.handle;
      addNewSessionForAccount(accountHandle, sessionInUrl);
    }
  }

  try {
    if (localStorage.getItem('jwt') && localStorage.getItem('jwt') != 'null') {
      console.log('Session found. Logging in...');      
      let action = await ibb.resumeSession(localStorage.getItem('jwt'));
      if (action.error.type && action.error.type != Module.ErrorType.E_INVOICING.value) {
        store.commit('setJWT', '');
        store.commit('setUser', null);
        localStorage.setItem('jwt', null);
        let action2 = await ibb.getAccountInfo();
        if (action2.error.type) {
          throw new Error('Error getting account info: ' + action2.error.type);
        }
        removeSession(action2.accountInfo.handle);
        console.warn('Invalid session: ' + action.error.type);
        return action.error.type;  
      }
      let username = action.email;
      let multiFactorAuth = action.intValue;

      let lang = localStorage.getItem('lang');
      if (lang != 'es' && lang != 'en')
      {
          lang = '';
      }

      const [, accountInfo, invoicingInfo] = await Promise.all([
        store.dispatch('updateUserInfo'),
        store.dispatch('updateAccountInfo'),
        store.dispatch('updateInvoicingInfo'),
      ]);
      let accountHandle = accountInfo.handle;
      let isReseller = accountInfo.isreseller;
      let features = accountInfo.features;

      let paymentMethod;
      if (invoicingInfo.paymentMethod !== undefined) {
        paymentMethod = invoicingInfo.paymentMethod.type;
      } else {
        paymentMethod = 0;
      }

      let user = JSON.parse('{"id":1,"email":"' + username + '","locale":"' + lang + '","viewMode":"mosaic","multiFactorAuth":' + multiFactorAuth +
                          `,"perm":{"admin":false,"execute":false,"create":true,"rename":true,
                                  "modify":true,"delete":true,"share":true,"download":true, "reseller":` + isReseller + ', "paymentMethod":' + paymentMethod + ', "features":' + features + `},
                          "commands":[],"lockPassword":false}`);

      if (action.error.type == Module.ErrorType.E_INVOICING.value) {
        console.log('Invoicing info required');
        store.commit('setJWT', username);
        store.commit('setUser', user);
        return Module.ErrorType.E_INVOICING.value;
      }

      action = await ibb.getNodes();
      if (action.error.type) {
        store.commit('setJWT', '');
        store.commit('setUser', null);
        localStorage.setItem('jwt', null);
        removeSession(accountHandle);
        console.warn('Error getting nodes: ' + action.error.type);
        return action.error.type;
      }
      store.commit('setJWT', username);
      store.commit('setUser', user);

      if (window.location.pathname.includes('/drive/')) {
        let JavaEventListenerClass = Module.EventListener.extend('EventListener', {
          onEvent: async function(event)
          {
            if (event.type == Module.EventType.LOGOUT.value)
            {
                location.reload();
                return;
            }
  
            if (event.type == Module.EventType.NEW_NODES.value || event.type == Module.EventType.UPDATED_NODE.value) {
              if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value) {
                store.commit('setReload', true);
                return;
              }
              let parentNode = await ibbLink.getNodeById(event.node.parentHandle);
              let handle = window.location.hash.replace('#', '');
              if ((parentNode.node.parentHandle !== '') && (handle === parentNode.node.handle)) {
                store.commit('setReload', true);
                return;
              } else if (parentNode.node.parentHandle === '' && window.location.hash === '') {
                let url = removePrefix(window.location.pathname);
                const node = await ibbLink.getNodeByPath(url);
                if (node.node.handle === parentNode.node.handle) {
                  store.commit('setReload', true);
                  return;
                }
              } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
                store.commit('setReload', true);
                return;
              }
            }
  
            if (event.type == Module.EventType.DELETED_NODE.value) {
              if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value) {
                store.commit('setReload', true);
                return;
              }
              let parentNode = await ibbLink.getNodeById(event.node.parentHandle);
              let handle = window.location.hash.replace('#', '');
              if ((parentNode.node.parentHandle !== '') && (handle === parentNode.node.handle)) {
                store.commit('setReload', true);
                return;
              } else if (parentNode.node.parentHandle === '' && window.location.hash === '') {
                let url = removePrefix(window.location.pathname);
                const node = await ibbLink.getNodeByPath(url);
                if (node.node.handle === parentNode.node.handle) {
                  store.commit('setReload', true);
                  return;
                }
              } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
                store.commit('setReload', true);
                return;
              } else if (event.node.handle === handle) {
                alert('El archivo/carpeta ha sido eliminado');
                router.push({path: window.location.pathname + '#' + event.node.parentHandle});
                return;
              }
            }
  
            if (event.type == Module.EventType.MOVED_NODE.value) {
              if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value) {
                store.commit('setReload', true);
                return;
              }
              let previousNode = await ibbLink.getNodeById(event.previousNode.parentHandle);
              let destinationNode = await ibbLink.getNodeById(event.node.parentHandle);
              let handle = window.location.hash.replace('#', '');
              if (((previousNode.node.parentHandle !== '') && (handle === previousNode.node.handle)) || ((destinationNode.node.parentHandle !== '') && (handle === destinationNode.node.handle))) {
                store.commit('setReload', true);
                return;
              } else if ((previousNode.node.parentHandle === '') || (destinationNode.node.parentHandle === '')) {
                let url = removePrefix(window.location.pathname);
                const node = await ibbLink.getNodeByPath(url);
                if ((node.node.handle === previousNode.node.handle) || (node.node.handle === destinationNode.node.handle)) {
                  if (destinationNode.node.name === 'Recycle Bin') {
                    router.push({path: window.location.pathname + '#' + previousNode.node.handle});
                    return;
                  } else {
                    store.commit('setReload', true);
                    return;
                  }
                }
              } else if (destinationNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
                store.commit('setReload', true);
                return;
              }
            }
          }
        });
  
        ibbLink.addEventListener(new JavaEventListenerClass());
      } else {
        let JavaEventListenerClass = Module.EventListener.extend('EventListener', {
          onEvent: async function(event)
          {
            if (event.type == Module.EventType.LOGOUT.value)
            {
                location.reload();
                return;
            }
  
            if (event.type == Module.EventType.NEW_NODES.value || event.type == Module.EventType.UPDATED_NODE.value) {
              if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value) {
                store.commit('setReload', true);
                return;
              }
              let parentNode = await ibb.getNodeById(event.node.parentHandle);
              let handle = window.location.hash.replace('#', '');
              if ((parentNode.node.parentHandle !== '') && (handle === parentNode.node.handle)) {
                store.commit('setReload', true);
                return;
              } else if (parentNode.node.parentHandle === '' && window.location.hash === '') {
                let url = removePrefix(window.location.pathname);
                const node = await ibb.getNodeByPath(url);
                if (node.node.handle === parentNode.node.handle) {
                  store.commit('setReload', true);
                  return;
                }
              } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
                store.commit('setReload', true);
                return;
              }
            }
  
            if (event.type == Module.EventType.DELETED_NODE.value) {
              if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value) {
                store.commit('setReload', true);
                return;
              }
              let parentNode = await ibb.getNodeById(event.node.parentHandle);
              let handle = window.location.hash.replace('#', '');
              if ((parentNode.node.parentHandle !== '') && (handle === parentNode.node.handle)) {
                store.commit('setReload', true);
                return;
              } else if (parentNode.node.parentHandle === '' && window.location.hash === '') {
                let url = removePrefix(window.location.pathname);
                const node = await ibb.getNodeByPath(url);
                if (node.node.handle === parentNode.node.handle) {
                  store.commit('setReload', true);
                  return;
                }
              } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
                store.commit('setReload', true);
                return;
              } else if (event.node.handle === handle) {
                alert('El archivo/carpeta ha sido eliminado');
                router.push({path: window.location.pathname + '#' + event.node.parentHandle});
                return;
              }
            }
  
            if (event.type == Module.EventType.MOVED_NODE.value) {
              if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value) {
                store.commit('setReload', true);
                return;
              }
              let previousNode = await ibb.getNodeById(event.previousNode.parentHandle);
              let destinationNode = await ibb.getNodeById(event.node.parentHandle);
              let handle = window.location.hash.replace('#', '');
              if (((previousNode.node.parentHandle !== '') && (handle === previousNode.node.handle)) || ((destinationNode.node.parentHandle !== '') && (handle === destinationNode.node.handle))) {
                store.commit('setReload', true);
                return;
              } else if ((previousNode.node.parentHandle === '') || (destinationNode.node.parentHandle === '')) {
                let url = removePrefix(window.location.pathname);
                const node = await ibb.getNodeByPath(url);
                if ((node.node.handle === previousNode.node.handle) || (node.node.handle === destinationNode.node.handle)) {
                  if (destinationNode.node.name === 'Recycle Bin') {
                    router.push({path: window.location.pathname + '#' + previousNode.node.handle});
                    return;
                  } else {
                    store.commit('setReload', true);
                    return;
                  }
                }
              } else if (destinationNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
                store.commit('setReload', true);
                return;
              }
            }
          }
        });
  
        ibb.addEventListener(new JavaEventListenerClass());
      }

      if (sessionInUrl)
      {
          router.replace({path: window.location.pathname});
      }

      return Module.ErrorType.E_SUCCESS.value;
    }
    else {
      console.log('Previous session not found');

      let JavaEventListenerClass = Module.EventListener.extend('EventListener', {
        onEvent: async function(event)
        {
          if (event.type == Module.EventType.NEW_NODES.value || event.type == Module.EventType.UPDATED_NODE.value) {
            let parentNode = await ibbLink.getNodeById(event.node.parentHandle);
            
            if ((parentNode.node.parentHandle !== '') && (handle === parentNode.node.handle)) {
              store.commit('setReload', true);
              return;
            } else if (parentNode.node.parentHandle === '' && window.location.hash === '') {
              let url = removePrefix(window.location.pathname);
              const node = await ibbLink.getNodeByPath(url);
              if (node.node.handle === parentNode.node.handle) {
                store.commit('setReload', true);
                return;
              }
            } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
              store.commit('setReload', true);
              return;
            }
          }

          if (event.type == Module.EventType.DELETED_NODE.value) {
            if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash === '') {
              store.commit('setReload', true);
              return;
            }
            let parentNode = await ibbLink.getNodeById(event.node.parentHandle);
            let handle = window.location.hash.replace('#', '');
            if ((parentNode.node.parentHandle !== '') && (handle === parentNode.node.handle)) {
              store.commit('setReload', true);
              return;
            } else if (parentNode.node.parentHandle === '' && window.location.hash === '') {
              let url = removePrefix(window.location.pathname);
              const node = await ibbLink.getNodeByPath(url);
              if (node.node.handle === parentNode.node.handle) {
                store.commit('setReload', true);
                return;
              }
            } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
              store.commit('setReload', true);
              return;
            } else if (event.node.handle === handle) {
              alert('El archivo/carpeta ha sido eliminado');
              router.push({path: window.location.pathname + '#' + event.node.parentHandle});
              return;
            }
          }

          if (event.type == Module.EventType.MOVED_NODE.value) {
            if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash === '') {
              store.commit('setReload', true);
              return;
            }
            let previousNode = await ibbLink.getNodeById(event.previousNode.parentHandle);
            let destinationNode = await ibbLink.getNodeById(event.node.parentHandle);
            let handle = window.location.hash.replace('#', '');
            if (((previousNode.node.parentHandle !== '') && (handle === previousNode.node.handle)) || ((destinationNode.node.parentHandle !== '') && (handle === destinationNode.node.handle))) {
              store.commit('setReload', true);
              return;
            } else if ((previousNode.node.parentHandle === '') || (destinationNode.node.parentHandle === '')) {
              let url = removePrefix(window.location.pathname);
              const node = await ibbLink.getNodeByPath(url);
              if ((node.node.handle === previousNode.node.handle) || (node.node.handle === destinationNode.node.handle)) {
                if (destinationNode.node.name === 'Recycle Bin') {
                  router.push({path: window.location.pathname + '#' + previousNode.node.handle});
                  return;
                } else {
                  store.commit('setReload', true);
                  return;
                }
              }
            } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
              store.commit('setReload', true);
              return;
            }
          }
        }
      });

      ibbLink.addEventListener(new JavaEventListenerClass());
      return Module.ErrorType.E_NOTFOUND.value;
    }
  } catch (_) {
    console.warn('Invalid JWT token in storage') // eslint-disable-line
    store.commit('setJWT', '');
    store.commit('setUser', null);
    localStorage.setItem('jwt', null);
    removeSession(accountHandle);
  }
}

export function addNewSessionForAccount(account, session) { 
  let sessions = JSON.parse(localStorage.getItem('sessions')) || {};
  sessions[account] = session;
  localStorage.setItem('sessions', JSON.stringify(sessions));
}

export function removeSession(account) { 
  let sessions = JSON.parse(localStorage.getItem('sessions')) || {};
  if (sessions[account]) {
    delete sessions[account];
  }
  localStorage.setItem('sessions', JSON.stringify(sessions));
}

export async function getSessionForAccount(account) { 
  let sessions = JSON.parse(localStorage.getItem('sessions')) || {};
  if (sessions[account]) {
    localStorage.setItem('jwt', sessions[account]);
    validateLogin();
  } else {
    await newSessionIntoAccount(account);
  }
}

export async function newSessionIntoAccount(handle) {
  let action = await ibb.newSessionIntoAccount(handle);
  if (action.error.type && action.error.type != Module.ErrorType.E_INVOICING.value) {
    store.commit('setJWT', '');
    store.commit('setUser', null);
    localStorage.setItem('jwt', null);
    removeSession(handle);
    console.warn('Invalid session: ' + action.error.type);
    return action.error.type;  
  } else {
    localStorage.setItem('jwt', action.session);
    addNewSessionForAccount(handle, action.session);
    validateLogin(); 
  }
}

export async function getNodes() {
  let action = await ibb.getNodes();
  if (action.error.type) {
    store.commit('setJWT', '');
    store.commit('setUser', null);
    localStorage.setItem('jwt', null);

    let action2 = await ibb.getAccountInfo();
    if (action2.error.type) {
      throw new Error('Error getting account info: ' + action2.error.type);
    }
    removeSession(action2.accountInfo.handle);
    throw new Error('Error getting nodes: ' + action.error.type);
  }

  let JavaEventListenerClass = Module.EventListener.extend('EventListener', {
    onEvent: async function(event)
    {
      if (event.type == Module.EventType.LOGOUT.value)
      {
          location.reload();
          return;
      }

      if (event.type == Module.EventType.NEW_NODES.value || event.type == Module.EventType.UPDATED_NODE.value) {
        if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value) {
          store.commit('setReload', true);
          return;
        }
        let parentNode = await ibb.getNodeById(event.node.parentHandle);
        let handle = window.location.hash.replace('#', '');
        if ((parentNode.node.parentHandle !== '') && (handle === parentNode.node.handle)) {
          store.commit('setReload', true);
          return;
        } else if (parentNode.node.parentHandle === '' && window.location.hash === '') {
          let url = removePrefix(window.location.pathname);
          const node = await ibb.getNodeByPath(url);
          if (node.node.handle === parentNode.node.handle) {
            store.commit('setReload', true);
            return;
          }
        } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
          store.commit('setReload', true);
          return;
        }
      }

      if (event.type == Module.EventType.DELETED_NODE.value) {
        if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value) {
          store.commit('setReload', true);
          return;
        }
        let parentNode = await ibb.getNodeById(event.node.parentHandle);
        let handle = window.location.hash.replace('#', '');
        if ((parentNode.node.parentHandle !== '') && (handle === parentNode.node.handle)) {
          store.commit('setReload', true);
          return;
        } else if (parentNode.node.parentHandle === '' && window.location.hash === '') {
          let url = removePrefix(window.location.pathname);
          const node = await ibb.getNodeByPath(url);
          if (node.node.handle === parentNode.node.handle) {
            store.commit('setReload', true);
            return;
          }
        } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
          store.commit('setReload', true);
          return;
        } else if (event.node.handle === handle) {
          alert('El archivo/carpeta ha sido eliminado');
          router.push({path: window.location.pathname + '#' + event.node.parentHandle});
          return;
        }
      }

      if (event.type == Module.EventType.MOVED_NODE.value) {
        if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value) {
          store.commit('setReload', true);
          return;
        }
        let previousNode = await ibb.getNodeById(event.previousNode.parentHandle);
        let destinationNode = await ibb.getNodeById(event.node.parentHandle);
        let handle = window.location.hash.replace('#', '');
        if (((previousNode.node.parentHandle !== '') && (handle === previousNode.node.handle)) || ((destinationNode.node.parentHandle !== '') && (handle === destinationNode.node.handle))) {
          store.commit('setReload', true);
          return;
        } else if ((previousNode.node.parentHandle === '') || (destinationNode.node.parentHandle === '')) {
          let url = removePrefix(window.location.pathname);
          const node = await ibb.getNodeByPath(url);
          if ((node.node.handle === previousNode.node.handle) || (node.node.handle === destinationNode.node.handle)) {
            if (destinationNode.node.name === 'Recycle Bin') {
              router.push({path: window.location.pathname + '#' + previousNode.node.handle});
              return;
            } else {
              store.commit('setReload', true);
              return;
            }
          }
        } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
          store.commit('setReload', true);
          return;
        }
      }
    }
  });

  ibb.addEventListener(new JavaEventListenerClass());
  return 0;
}

export async function login (username, password, recaptch, code) {
  
  let action;
  if (typeof code === 'undefined') {
    action = await ibb.login(username, password);
  } else {
    action = await ibb.login2fa(username, password, code);
  }

  if (action.error.type && action.error.type != Module.ErrorType.E_INVOICING.value) {
    return action.error.type;
  }

  const multiFactorAuth = action.intValue;
  const session = action.session;

  let lang = localStorage.getItem('lang');
  if (lang != 'es' && lang != 'en') {
    lang = '';
  }

  const [, accountInfo, invoicingInfo] = await Promise.all([
    store.dispatch('updateUserInfo'),
    store.dispatch('updateAccountInfo'),
    store.dispatch('updateInvoicingInfo'),
  ]);

  const isReseller = accountInfo.isreseller;
  const accountHandle = accountInfo.handle;
  const features = accountInfo.features;
  const paymentMethod = invoicingInfo.paymentMethod ? invoicingInfo.paymentMethod.type : 0;

  const user = JSON.parse('{"id":1,"email":"' + username + '","locale":"' + lang + '","viewMode":"mosaic","multiFactorAuth":' + multiFactorAuth + `,
  "perm":{"admin":false,"execute":false,"create":true,"rename":true, "modify":true,"delete":true,"share":true,"download":true, "reseller":` + isReseller + ', "paymentMethod":' 
  + paymentMethod + ', "features":' + features + '}, "commands":[],"lockPassword":false}');

  localStorage.setItem('jwt', session);
  addNewSessionForAccount(accountHandle, session);
  store.commit('setJWT', username);
  store.commit('setUser', user);

  if (action.error.type == Module.ErrorType.E_INVOICING.value) {
    return action.error.type;
  }

  const result = await getNodes();
  return result;
}

export async function validate (username, firstname, lastname) {
  let action = await ibb.verifyEmail(username, firstname, lastname);
  if (action.error.type) {
    console.log('Error in verifyEmail');
    throw action.error.type;
  }
  return action.text;
}

export async function joinAccountWithCurrentUser (account, accountKey) {
  let action = await ibb.joinAccountWithCurrentUser(account, accountKey);
  if (action.error.type && action.error.type != Module.ErrorType.E_INVOICING.value) {
    store.commit('setJWT', '');
    store.commit('setUser', null);
    localStorage.setItem('jwt', null);
    removeSession(account);
    console.warn('Invalid session: ' + action.error.type);
    return action.error.type;  
  } else {
    localStorage.setItem('jwt', action.session);
    addNewSessionForAccount(account, action.session);
  }
}

export async function forgotPassword (username) {
  let action = await ibb.forgotPassword(username);
  if (action.error.type) {
    console.log('Error starting forgotPassword');
    throw action.error.type;
  }
  return action.text;
}

export async function createAccountForCurrentUser (username, referrerCode) {
  let action = await ibb.createAccountForCurrentUser(referrerCode);
  if (action.error.type && action.error.type != Module.ErrorType.E_INVOICING.value) {
    throw action.error.type;
  }

  let session = action.session;
  let lang = localStorage.getItem('lang');
  if (lang != 'es' && lang != 'en')
  {
      lang = '';
  }

  let action2 = await ibb.getAccountInfo();
  if (action2.error.type) {
    throw new Error('Error getting account info: ' + action2.error.type);
  }
  let isReseller = action2.accountInfo.isreseller;
  let accountHandle = action2.accountInfo.handle;
  let features = action2.accountInfo.features;

  let action3 = await ibb.getInvoicingInfo();
  if (action3.error.type) {
    return null;
  }

  let paymentMethod;
  if (action3.invoicingInfo.paymentMethod !== undefined) {
    paymentMethod = action3.invoicingInfo.paymentMethod.type;
  } else {
    paymentMethod = 0;
  }

  let user = JSON.parse('{"id":1,"email":"' + username + '","locale":"' + lang + `","viewMode":"mosaic","multiFactorAuth":0,
                        "perm":{"admin":false,"execute":false,"create":true,"rename":true,
                        "modify":true,"delete":true,"share":true,"download":true, "reseller":` + isReseller + ', "paymentMethod":' + paymentMethod + ', "features":' + features + `},
                        "commands":[],"lockPassword":false}`);


  localStorage.setItem('jwt', session);
  addNewSessionForAccount(accountHandle, session);
  store.commit('setJWT', username);
  store.commit('setUser', user);
                            
  if (action.error.type && action.error.type == Module.ErrorType.E_INVOICING.value) {
    throw action.error.type;
  }

  action = await ibb.getNodes();
  if (action.error.type) {
    console.log('Error getting nodes');
    store.commit('setJWT', '');
    store.commit('setUser', null);
    localStorage.setItem('jwt', null);
    removeSession(accountHandle);
    throw new Error('Error getting nodes: ' + action.error.type);
  }

  let JavaEventListenerClass = Module.EventListener.extend('EventListener', {
    onEvent: async function(event)
    {
      if (event.type == Module.EventType.LOGOUT.value)
      {
          location.reload();
          return;
      }

      if (event.type == Module.EventType.NEW_NODES.value || event.type == Module.EventType.UPDATED_NODE.value) {
        if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash === '') {
          store.commit('setReload', true);
          return;
        }
        let parentNode = await ibb.getNodeById(event.node.parentHandle);
        let handle = window.location.hash.replace('#', '');
        if ((parentNode.node.parentHandle !== '') && (handle === parentNode.node.handle)) {
          store.commit('setReload', true);
          return;
        } else if (parentNode.node.parentHandle === '' && window.location.hash === '') {
          let url = removePrefix(window.location.pathname);
          const node = await ibb.getNodeByPath(url);
          if (node.node.handle === parentNode.node.handle) {
            store.commit('setReload', true);
            return;
          }
        } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
          store.commit('setReload', true);
          return;
        }
      }

      if (event.type == Module.EventType.DELETED_NODE.value) {
        if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash === '') {
          store.commit('setReload', true);
          return;
        }
        let parentNode = await ibb.getNodeById(event.node.parentHandle);
        let handle = window.location.hash.replace('#', '');
        if ((parentNode.node.parentHandle !== '') && (handle === parentNode.node.handle)) {
          store.commit('setReload', true);
          return;
        } else if (parentNode.node.parentHandle === '' && window.location.hash === '') {
          let url = removePrefix(window.location.pathname);
          const node = await ibb.getNodeByPath(url);
          if (node.node.handle === parentNode.node.handle) {
            store.commit('setReload', true);
            return;
          }
        } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
          store.commit('setReload', true);
          return;
        } else if (event.node.handle === handle) {
          alert('El archivo/carpeta ha sido eliminado');
          router.push({path: window.location.pathname + '#' + event.node.parentHandle});
          return;
        }
      }

      if (event.type == Module.EventType.MOVED_NODE.value) {
        if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash === '') {
          store.commit('setReload', true);
          return;
        }
        let previousNode = await ibb.getNodeById(event.previousNode.parentHandle);
        let destinationNode = await ibb.getNodeById(event.node.parentHandle);
        let handle = window.location.hash.replace('#', '');
        if (((previousNode.node.parentHandle !== '') && (handle === previousNode.node.handle)) || ((destinationNode.node.parentHandle !== '') && (handle === destinationNode.node.handle))) {
          store.commit('setReload', true);
          return;
        } else if ((previousNode.node.parentHandle === '') || (destinationNode.node.parentHandle === '')) {
          let url = removePrefix(window.location.pathname);
          const node = await ibb.getNodeByPath(url);
          if ((node.node.handle === previousNode.node.handle) || (node.node.handle === destinationNode.node.handle)) {
            if (destinationNode.node.name === 'Recycle Bin') {
              router.push({path: window.location.pathname + '#' + previousNode.node.handle});
              return;
            } else {
              store.commit('setReload', true);
              return;
            }
          }
        } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
          store.commit('setReload', true);
          return;
        }
      }
    }
  });

  ibb.addEventListener(new JavaEventListenerClass());

  return;
}

export async function joinAccount (account, accountKey, id, firstname, lastname, username, password, pin) {
  let action = await ibb.joinAccount(account, accountKey, id, firstname, lastname, username, password, parseInt(pin));
  if (action.error.type && action.error.type != Module.ErrorType.E_INVOICING.value) {
    console.log('Error in joinAccount:', action.error.type);
    throw action.error.type;
  }

  let session = action.session;
  let lang = localStorage.getItem('lang');
  if (lang != 'es' && lang != 'en')
  {
      lang = '';
  }

  let action2 = await ibb.getAccountInfo();
  if (action2.error.type) {
    throw new Error('Error getting account info: ' + action2.error.type);
  }
  let isReseller = action2.accountInfo.isreseller;
  let accountHandle = action2.accountInfo.handle;
  let features = action2.accountInfo.features;

  let action3 = await ibb.getInvoicingInfo();
  if (action3.error.type) {
    return null;
  }

  let paymentMethod;
  if (action3.invoicingInfo.paymentMethod !== undefined) {
    paymentMethod = action3.invoicingInfo.paymentMethod.type;
  } else {
    paymentMethod = 0;
  }

  let user = JSON.parse('{"id":1,"email":"' + username + '","locale":"' + lang + `","viewMode":"mosaic","multiFactorAuth":0
                      ,"perm":{"admin":false,"execute":false,"create":true,"rename":true,
                              "modify":true,"delete":true,"share":true,"download":true, "reseller":` + isReseller + ', "paymentMethod":' + paymentMethod + ', "features":' + features + `},
                      "commands":[],"lockPassword":false}`);


  localStorage.setItem('jwt', session);
  addNewSessionForAccount(accountHandle, session);
  store.commit('setJWT', username);
  store.commit('setUser', user);
                            
  if (action.error.type && action.error.type == Module.ErrorType.E_INVOICING.value) {
    throw action.error.type;
  }

  action = await ibb.getNodes();
  if (action.error.type) {
    console.log('Error getting nodes');
    store.commit('setJWT', '');
    store.commit('setUser', null);
    localStorage.setItem('jwt', null);
    removeSession(accountHandle);
    throw new Error('Error getting nodes: ' + action.error.type);
  }

  let JavaEventListenerClass = Module.EventListener.extend('EventListener', {
    onEvent: async function(event)
    {
      if (event.type == Module.EventType.LOGOUT.value)
      {
          location.reload();
          return;
      }

      if (event.type == Module.EventType.NEW_NODES.value || event.type == Module.EventType.UPDATED_NODE.value) {
        if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash === '') {
          store.commit('setReload', true);
          return;
        }
        let parentNode = await ibb.getNodeById(event.node.parentHandle);
        let handle = window.location.hash.replace('#', '');
        if ((parentNode.node.parentHandle !== '') && (handle === parentNode.node.handle)) {
          store.commit('setReload', true);
          return;
        } else if (parentNode.node.parentHandle === '' && window.location.hash === '') {
          let url = removePrefix(window.location.pathname);
          const node = await ibb.getNodeByPath(url);
          if (node.node.handle === parentNode.node.handle) {
            store.commit('setReload', true);
            return;
          }
        } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
          store.commit('setReload', true);
          return;
        }
      }

      if (event.type == Module.EventType.DELETED_NODE.value) {
        if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash === '') {
          store.commit('setReload', true);
          return;
        }
        let parentNode = await ibb.getNodeById(event.node.parentHandle);
        let handle = window.location.hash.replace('#', '');
        if ((parentNode.node.parentHandle !== '') && (handle === parentNode.node.handle)) {
          store.commit('setReload', true);
          return;
        } else if (parentNode.node.parentHandle === '' && window.location.hash === '') {
          let url = removePrefix(window.location.pathname);
          const node = await ibb.getNodeByPath(url);
          if (node.node.handle === parentNode.node.handle) {
            store.commit('setReload', true);
            return;
          }
        } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
          store.commit('setReload', true);
          return;
        } else if (event.node.handle === handle) {
          alert('El archivo/carpeta ha sido eliminado');
          router.push({path: window.location.pathname + '#' + event.node.parentHandle});
          return;
        }
      }

      if (event.type == Module.EventType.MOVED_NODE.value) {
        if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash === '') {
          store.commit('setReload', true);
          return;
        }
        let previousNode = await ibb.getNodeById(event.previousNode.parentHandle);
        let destinationNode = await ibb.getNodeById(event.node.parentHandle);
        let handle = window.location.hash.replace('#', '');
        if (((previousNode.node.parentHandle !== '') && (handle === previousNode.node.handle)) || ((destinationNode.node.parentHandle !== '') && (handle === destinationNode.node.handle))) {
          store.commit('setReload', true);
          return;
        } else if ((previousNode.node.parentHandle === '') || (destinationNode.node.parentHandle === '')) {
          let url = removePrefix(window.location.pathname);
          const node = await ibb.getNodeByPath(url);
          if ((node.node.handle === previousNode.node.handle) || (node.node.handle === destinationNode.node.handle)) {
            if (destinationNode.node.name === 'Recycle Bin') {
              router.push({path: window.location.pathname + '#' + previousNode.node.handle});
              return;
            } else {
              store.commit('setReload', true);
              return;
            }
          }
        } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
          store.commit('setReload', true);
          return;
        }
      }
    }
  });

  ibb.addEventListener(new JavaEventListenerClass());

  return;
}

export async function signup (id, username, password, pin, firstname, lastname, referrerCode, planId) {
  let action = await ibb.createAccountWithPlan(id, firstname, lastname, username, password, parseInt(pin), referrerCode, planId);
  if (action.error.type && action.error.type != Module.ErrorType.E_INVOICING.value) {
    console.log('Error in createAccountWithPlan');
    throw action.error.type;
  }

  let session = action.session;
  let lang = localStorage.getItem('lang');
  if (lang != 'es' && lang != 'en')
  {
      lang = '';
  }

  let action2 = await ibb.getAccountInfo();
  if (action2.error.type) {
    throw new Error('Error getting account info: ' + action2.error.type);
  }
  let isReseller = action2.accountInfo.isreseller;
  let accountHandle = action2.accountInfo.handle;
  let features = action2.accountInfo.features;

  let action3 = await ibb.getInvoicingInfo();
  if (action3.error.type) {
    return null;
  }

  let paymentMethod;
  if (action3.invoicingInfo.paymentMethod !== undefined) {
    paymentMethod = action3.invoicingInfo.paymentMethod.type;
  } else {
    paymentMethod = 0;
  }

  let user = JSON.parse('{"id":1,"email":"' + username + '","locale":"' + lang + `","viewMode":"mosaic","multiFactorAuth":0,
  "perm":{"admin":false,"execute":false,"create":true,"rename":true,
                              "modify":true,"delete":true,"share":true,"download":true, "reseller":` + isReseller + ', "paymentMethod":' + paymentMethod + ', "features":' + features + `},
                      "commands":[],"lockPassword":false}`);


  localStorage.setItem('jwt', session);
  addNewSessionForAccount(accountHandle, session);
  store.commit('setJWT', username);
  store.commit('setUser', user);
  store.dispatch('updateUserInfo');
                            
  if (action.error.type && action.error.type == Module.ErrorType.E_INVOICING.value) {
    throw action.error.type;
  }

  action = await ibb.getNodes();
  if (action.error.type) {
    console.log('Error getting nodes');
    store.commit('setJWT', '');
    store.commit('setUser', null);
    localStorage.setItem('jwt', null);
    removeSession(accountHandle);
    throw new Error('Error getting nodes: ' + action.error.type);
  }

  let JavaEventListenerClass = Module.EventListener.extend('EventListener', {
    onEvent: async function(event)
    {
      if (event.type == Module.EventType.LOGOUT.value)
      {
          location.reload();
          return;
      }

      if (event.type == Module.EventType.NEW_NODES.value || event.type == Module.EventType.UPDATED_NODE.value) {
        if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash === '') {
          store.commit('setReload', true);
          return;
        }
        let parentNode = await ibb.getNodeById(event.node.parentHandle);
        let handle = window.location.hash.replace('#', '');
        if ((parentNode.node.parentHandle !== '') && (handle === parentNode.node.handle)) {
          store.commit('setReload', true);
          return;
        } else if (parentNode.node.parentHandle === '' && window.location.hash === '') {
          let url = removePrefix(window.location.pathname);
          const node = await ibb.getNodeByPath(url);
          if (node.node.handle === parentNode.node.handle) {
            store.commit('setReload', true);
            return;
          }
        } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
          store.commit('setReload', true);
          return;
        }
      }

      if (event.type == Module.EventType.DELETED_NODE.value) {
        if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash === '') {
          store.commit('setReload', true);
          return;
        }
        let parentNode = await ibb.getNodeById(event.node.parentHandle);
        let handle = window.location.hash.replace('#', '');
        if ((parentNode.node.parentHandle !== '') && (handle === parentNode.node.handle)) {
          store.commit('setReload', true);
          return;
        } else if (parentNode.node.parentHandle === '' && window.location.hash === '') {
          let url = removePrefix(window.location.pathname);
          const node = await ibb.getNodeByPath(url);
          if (node.node.handle === parentNode.node.handle) {
            store.commit('setReload', true);
            return;
          }
        } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
          store.commit('setReload', true);
          return;
        } else if (event.node.handle === handle) {
          alert('El archivo/carpeta ha sido eliminado');
          router.push({path: window.location.pathname + '#' + event.node.parentHandle});
          return;
        }
      }

      if (event.type == Module.EventType.MOVED_NODE.value) {
        if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash === '') {
          store.commit('setReload', true);
          return;
        }
        let previousNode = await ibb.getNodeById(event.previousNode.parentHandle);
        let destinationNode = await ibb.getNodeById(event.node.parentHandle);
        let handle = window.location.hash.replace('#', '');
        if (((previousNode.node.parentHandle !== '') && (handle === previousNode.node.handle)) || ((destinationNode.node.parentHandle !== '') && (handle === destinationNode.node.handle))) {
          store.commit('setReload', true);
          return;
        } else if ((previousNode.node.parentHandle === '') || (destinationNode.node.parentHandle === '')) {
          let url = removePrefix(window.location.pathname);
          const node = await ibb.getNodeByPath(url);
          if ((node.node.handle === previousNode.node.handle) || (node.node.handle === destinationNode.node.handle)) {
            if (destinationNode.node.name === 'Recycle Bin') {
              router.push({path: window.location.pathname + '#' + previousNode.node.handle});
              return;
            } else {
              store.commit('setReload', true);
              return;
            }
          }
        } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
          store.commit('setReload', true);
          return;
        }
      }
    }
  });

  ibb.addEventListener(new JavaEventListenerClass());

  return;
}

export async function recoverAccount (id, username, recoveryKey, pin, code) {

  let action;
  if (typeof code === 'undefined')
  {
    action = await ibb.recoverAccount(id, username, recoveryKey, parseInt(pin));
    if (action.error.type) {
      console.log('Error in recoverAccount: ' + action.error.type);
      return action.error.type;
    }
  }
  else
  {
    action = await ibb.recoverAccount2fa(id, username, recoveryKey, parseInt(pin), parseInt(code));
    if (action.error.type) {
      console.log('Error in recoverAccount2fa: ' + action.error.type);
      return action.error.type;
    }
  }

  let multiFactorAuth = action.intValue;
  let session = action.session;
  action = await ibb.getNodes();
  if (action.error.type) {
    throw new Error('Error getting nodes: ' + action.error.type);
  }

  let lang = localStorage.getItem('lang');
  if (lang != 'es' && lang != 'en')
  {
      lang = '';
  }

  let action2 = await ibb.getAccountInfo();
  if (action2.error.type) {
    throw new Error('Error getting account info: ' + action2.error.type);
  }
  let isReseller = action2.accountInfo.isreseller;
  let accountHandle = action2.accountInfo.handle;
  let features = action2.accountInfo.features;

  let action3 = await ibb.getInvoicingInfo();
  if (action3.error.type) {
    return null;
  }

  let paymentMethod;
  if (action3.invoicingInfo.paymentMethod !== undefined) {
    paymentMethod = action3.invoicingInfo.paymentMethod.type;
  } else {
    paymentMethod = 0;
  }

  let user = JSON.parse('{"id":1,"email":"' + username + '","locale":"' + lang + '","viewMode":"mosaic","multiFactorAuth":' + multiFactorAuth +
                      `,"perm":{"admin":false,"execute":false,"create":true,"rename":true,
                              "modify":true,"delete":true,"share":true,"download":true, "reseller":` + isReseller + ', "paymentMethod":' + paymentMethod + ', "features":' + features + `},
                      "commands":[],"lockPassword":false}`);

  localStorage.setItem('jwt', session);
  addNewSessionForAccount(accountHandle, session);
  store.commit('setJWT', username);
  store.commit('setUser', user);

  let JavaEventListenerClass = Module.EventListener.extend('EventListener', {
    onEvent: async function(event)
    {
      if (event.type == Module.EventType.LOGOUT.value)
      {
          location.reload();
          return;
      }

      if (event.type == Module.EventType.NEW_NODES.value || event.type == Module.EventType.UPDATED_NODE.value) {
        if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash === '') {
          store.commit('setReload', true);
          return;
        }
        let parentNode = await ibb.getNodeById(event.node.parentHandle);
        let handle = window.location.hash.replace('#', '');
        if ((parentNode.node.parentHandle !== '') && (handle === parentNode.node.handle)) {
          store.commit('setReload', true);
          return;
        } else if (parentNode.node.parentHandle === '' && window.location.hash === '') {
          let url = removePrefix(window.location.pathname);
          const node = await ibb.getNodeByPath(url);
          if (node.node.handle === parentNode.node.handle) {
            store.commit('setReload', true);
            return;
          }
        } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
          store.commit('setReload', true);
          return;
        }
      }

      if (event.type == Module.EventType.DELETED_NODE.value) {
        if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash === '') {
          store.commit('setReload', true);
          return;
        }
        let parentNode = await ibb.getNodeById(event.node.parentHandle);
        let handle = window.location.hash.replace('#', '');
        if ((parentNode.node.parentHandle !== '') && (handle === parentNode.node.handle)) {
          store.commit('setReload', true);
          return;
        } else if (parentNode.node.parentHandle === '' && window.location.hash === '') {
          let url = removePrefix(window.location.pathname);
          const node = await ibb.getNodeByPath(url);
          if (node.node.handle === parentNode.node.handle) {
            store.commit('setReload', true);
            return;
          }
        } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
          store.commit('setReload', true);
          return;
        } else if (event.node.handle === handle) {
          alert('El archivo/carpeta ha sido eliminado');
          router.push({path: window.location.pathname + '#' + event.node.parentHandle});
          return;
        }
      }

      if (event.type == Module.EventType.MOVED_NODE.value) {
        if (event.node.parentHandle === '' && event.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash === '') {
          store.commit('setReload', true);
          return;
        }
        let previousNode = await ibb.getNodeById(event.previousNode.parentHandle);
        let destinationNode = await ibb.getNodeById(event.node.parentHandle);
        let handle = window.location.hash.replace('#', '');
        if (((previousNode.node.parentHandle !== '') && (handle === previousNode.node.handle)) || ((destinationNode.node.parentHandle !== '') && (handle === destinationNode.node.handle))) {
          store.commit('setReload', true);
          return;
        } else if ((previousNode.node.parentHandle === '') || (destinationNode.node.parentHandle === '')) {
          let url = removePrefix(window.location.pathname);
          const node = await ibb.getNodeByPath(url);
          if ((node.node.handle === previousNode.node.handle) || (node.node.handle === destinationNode.node.handle)) {
            if (destinationNode.node.name === 'Recycle Bin') {
              router.push({path: window.location.pathname + '#' + previousNode.node.handle});
              return;
            } else {
              store.commit('setReload', true);
              return;
            }
          }
        } else if (parentNode.node.type === Module.NodeType.SHARED_DRIVE_ROOT.value && window.location.hash !== '') {
          store.commit('setReload', true);
          return;
        }
      }
    }
  });

  ibb.addEventListener(new JavaEventListenerClass());

  return 0;
}

export async function deleteAccount (handle, optionSelected) {
  let action = await ibb.deleteAccount(optionSelected);
  if (action.error.type) {
    throw new Error('Error deletting account' + action.error.type);
  } 
  removeSession(handle);
  await ibb.logout();
  store.commit('setJWT', '');
  store.commit('setUser', null);
  localStorage.setItem('jwt', null);
  localStorage.setItem('lang', null);
  router.push({path: '/login'});
}

export async function logout () {
  let action = await ibb.getAccountInfo();
  if (action.error.type) {
    throw new Error('Error getting account info: ' + action.error.type);
  }
  let handle = action.accountInfo.handle;
  removeSession(handle);
  await ibb.logout();
  store.commit('setJWT', '');
  store.commit('setUser', null);
  localStorage.setItem('jwt', null);
  localStorage.setItem('lang', null);
  router.push({path: '/login'});
}

export async function logoutJoin () {
  let action = await ibb.getAccountInfo();
  if (action.error.type) {
    throw new Error('Error getting account info: ' + action.error.type);
  }
  let handle = action.accountInfo.handle;
  removeSession(handle);
  await ibb.logout();
  store.commit('setJWT', '');
  store.commit('setUser', null);
  localStorage.setItem('jwt', null);
  localStorage.setItem('lang', null);
}
